import { MotionSourceBinaryData, MotionSourceData } from '../data/FlyerData';
import { MotionSourceType } from './MotionSource';
import { MuteMotionSource } from './MuteMotionSource';

export class BinaryMotionSource extends MuteMotionSource {
  type = MotionSourceType.Binary;
  private _centerPointX: number = 0.5;

  get centerPointX(): number {
    return this._centerPointX;
  }
  set centerPointX(value: number) {
    this._centerPointX = value;
    this._isCustom = value !== 0.5;
  }

  populateWithData(data: MotionSourceData) {
    super.populateWithData(data);

    const binaryData = data as MotionSourceBinaryData;
    this._centerPointX = binaryData.cx;
  }

  asData(): MotionSourceData {
    const result: MotionSourceBinaryData = {
      ...super.asData(),
      cx: this._centerPointX
    };
    return result;
  }

  getLevelAt(millis: number, option: any = undefined): number {
    const position = (millis % this.getLoopDuration()) / this.getLoopDuration();
    return position < this._centerPointX ? 0 : 1;
  }
}



// WEBPACK FOOTER //
// ./src/motion/BinaryMotionSource.ts